import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../vos/auth.service';

type CachedResponse = { cachedAt: number; expiresAt: number };
type HttpCachedRequestOptions = {
  url: string;
  isAuthenticated: boolean;
  timeInMinutes: number;
};

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  responses = new Map<string, CachedResponse>();

  constructor(private http: HttpClient, private authService: AuthService) {}

  cacheResponse(request_url: string, response: any, time_in_minutes: number) {
    const now = new Date(Date.now()).getTime();
    this.responses.set(request_url, {
      ...response,
      cachedAt: now,
      expiresAt: time_in_minutes * 60 * 1000,
    });
  }

  getResponseCached(request_url: string) {
    const now = new Date(Date.now()).getTime();
    const response = this.responses.get(request_url) as {
      cachedAt: number;
      expiresAt: number;
    };

    if (response) {
      if (now - response.cachedAt > response.expiresAt) {
        this.responses.delete(request_url);
        return null;
      }
    }

    return response;
  }

  callHttpRequestWithCache({
    url,
    isAuthenticated,
    timeInMinutes,
  }: HttpCachedRequestOptions) {
    const data = this.getResponseCached(url);

    if (data) {
      delete data.cachedAt;
      delete data.expiresAt;

      return new Observable((observe) => {
        return observe.next(data);
      });
    }

    const httpOptions = {
      headers: this.authService.userToken(),
    };

    if (!isAuthenticated) {
      delete httpOptions.headers;
    }

    return this.http.get(url, httpOptions).pipe(
      map((data: any) => {
        this.cacheResponse(url, data, timeInMinutes);
        return data;
      })
    );
  }
}
